// extracted by mini-css-extract-plugin
module.exports = {"bug":"modal-module--bug--3Ol4R","modal":"modal-module--modal--vaLun","overlay":"modal-module--overlay--2xKty"};